// CheticampInformation.jsx
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
// import List from "@mui/material/List";
// import li from "@mui/material/li";
import MKBox from "components/MKBox";
import PropTypes from "prop-types"


import { useState } from "react";
import {
  Card,
  CardContent,
  Dialog,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


const sections = [
    { id: "candidates", label: "Candidate Information" },
  { id: "new-boundary", label: "New Electoral Boundary/Nouvelle délimitation" },
  { id: "district-info", label: "Know Your Electoral District/Apprenez à connaître votre circonscription électorale" },
  { id: "french-services", label: "French Language Services/Services en français " },
  { id: "election-workers", label: "Election Workers Needed/Besoin de personnel électoral" },
  { id: "voting-options", label: "Notice of election – Voting Options/Avis d’élection " },
  // { id: "where-vote", label: "Where Do I Vote?" },
  // { id: "vic", label: "Voter Information Cards" },
  // { id: "who-can-vote", label: "Who Can Vote in this by-election?" },
  { id: "register", label: "Register to Vote/Inscrivez-vous pour voter lors de l’élection" },
  { id: "bring-id", label: "Bring Your ID/Apportez une pièce d’identité" },
  { id: "write-in", label: "Remote Voting - Write-in Ballot/Bulletin de vote en blanc" },
  { id: "e-ballot", label: "Early Voting – e-Ballot/Vote électronique pour le vote anticipé" },
  { id: "internet-voting", label: "Is Internet Voting Available?/Est-il possible de voter sur Internet?" },
  // { id: "accessibility", label: "Accessibility & Accommodations" },
  { id: "media", label: "Media Releases" },
  { id: "signage", label: "Election Signage/Publicité électorale et de tiers" },
  { id: "campaign-access", label: "Campaign Access to Buildings/Accès des équipes de campagne aux immeubles à logements multiples" }
];



const ResponsiveImage = ({ src, alt }) => {
  

const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        component="img"
        src={src}
        alt={alt}
        onClick={() => setOpen(true)}
        sx={{
          width: "100%",
          maxWidth: 600,
          height: "auto",
          mx: "auto",
          my: 3,
          display: "block",
          cursor: "zoom-in",
          borderRadius: 2,
        }}
      />

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{
            width: "100%",
            height: "auto",
          }}
        />
      </Dialog>
    </>
  );
};




ResponsiveImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

function CheticampInformation() {
  
  const handleJump = (event) => {
    const id = event.target.value;
    setSelectedSection(id);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const [selectedSection, setSelectedSection] = useState(sections[0].id);
  return (
    <MKBox component="section" py={{ xs: 6, md: 10 }}>
      <Container maxWidth="lg">
        <Typography variant="h3" mb={3}>
          Chéticamp-Margarees-Pleasant Bay By-election
        </Typography>
        <ResponsiveImage src="/img/website image 1.jpg" alt="Electoral district map" />

        <Typography mb={4}>
          The Chief Electoral Officer (CEO), Dorothy Rice, has received an order from the Governor in Council for a by-election in the new electoral district of Chéticamp-Margarees-Pleasant Bay. The CEO has issued a writ of election for Chéticamp-Margarees-Pleasant Bay and election day will be Tuesday, June 23, 2026.
        </Typography>

        <Typography mb={4}>
          Find all the information you need to know about the Chéticamp-Margarees-Pleasant Bay by-election right here. For daily updates, follow Elections Nova Scotia on Facebook, Bluesky, Instagram, and X (Twitter) @electionsns.
        </Typography>
       
        <Typography variant="h3" mb={3}>
          Élection partielle - Chéticamp-Margarees-Pleasant Bay 
        </Typography>
        {/* <ResponsiveImage src="/img/website image 1.jpg" alt="Electoral district map" /> */}

        <Typography mb={4}>
          La directrice générale des élections, Dorothy Rice, a reçu du gouverneur en conseil l’ordre d’organiser une élection partielle dans la nouvelle circonscription de Chéticamp-Margarees-Pleasant Bay. Elle a donc publié un bref d’élection; le jour du scrutin aura lieu le mardi 23 juin 2026.
        </Typography>

        <Typography mb={4}>
          Vous trouverez ici toutes les informations nécessaires sur l’élection partielle de la circonscription de Chéticamp-Margarees-Pleasant Bay. Suivez Élections Nouvelle-Écosse sur Facebook, Bluesky, Instagram et X (Twitter) @electionsns pour vous tenir au courant.
        </Typography>

        
        <Card
          sx={{
            backgroundColor: "#f2f2f2",
            borderRadius: 3,
            mb: 6,
            overflow: "visible",
          }}
        >
          <CardContent>
            <Typography
              variant="h4"
              gutterBottom
              textAlign="center"
            >
              Quick Navigation
            </Typography>

            {/* ✅ Centered dropdown */}
            <Box display="flex" justifyContent="center">
              <FormControl fullWidth sx={{ maxWidth: 620 }}>
                <InputLabel id="jump-label">
                  Jump to Section
                </InputLabel>

                <Select
                  labelId="jump-label"
                  value={selectedSection}
                  label="Jump to Section"
                  onChange={handleJump}
                  IconComponent={KeyboardArrowDownIcon}
                  sx={{
                    minHeight: 48,
                    backgroundColor: "white",
                    borderRadius: 2,
                    "& .MuiSelect-icon": {
                      color: "text.primary",
                      fontSize: 28,
                    },
                  }}
                >

                  {sections.map((s) => (
                    <MenuItem key={s.id} value={s.id}>
                      {s.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </CardContent>
        </Card>

        <Box id="candidates" mb={8}>
          <Typography variant="h4" mb={2}>Candidate Information</Typography>
          <Typography>
            <a href = "/ChéticampBy-election2026_Candidates">Click here to find out who is running in the Chéticamp-Margarees-Pleasant Bay by-election.</a>
          </Typography>
        </Box>

        <Box id="new-boundary" mb={8}>
          <Typography variant="h4" mb={2}>New Electoral Boundary</Typography>
          <Typography>
            Legislation was introduced in February 2026 to create a new exceptional electoral district called Chéticamp-Margarees-Pleasant Bay out of the existing Inverness electoral district. Amendments to the <a href = "https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">House of Assembly Act</a> implement the recommendations of the <a href ="https://www.nselectoralboundariescommission2025.ca/">2025 Electoral Boundaries Commission</a>, which released its final report January 30, 2026.
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Nouvelle délimitation</Typography>
          <Typography>
            Une loi a été introduite en février 2026 afin de créer une nouvelle circonscription électorale exceptionnelle, appelée Chéticamp-Margarees-Pleasant Bay, pour remplacer la circonscription d’Inverness. Les modifications apportées à la loi sur la Chambre d’assemblée  <a href = "https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">(House of Assembly Act)</a> visent à mettre en œuvre les recommandations de la  <a href ="https://www.nselectoralboundariescommission2025.ca/">Commission de délimitation des circonscriptions électorales de 2025</a>, qui a publié son rapport final le 30 janvier 2026.
          </Typography>
        </Box>

        <Box id="district-info" mb={8}>
          <Typography variant="h4" mb={2}>Know Your Electoral District</Typography>
          <Typography>
            Residents of Chéticamp-Margarees-Pleasant Bay are encouraged to use the following links to connect with information and maps of their new exceptional electoral district.
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Apprenez à connaître votre circonscription électorale</Typography>
          <Typography>
            Nous invitons les habitants de Chéticamp-Margarees-Pleasant Bay à cliquer sur les liens suivants pour obtenir des informations et consulter les cartes de leur nouvelle circonscription électorale. Ces ressources sont disponibles uniquement en anglais.
          </Typography>
          <br/>
          <Typography>
              <ul>Click here to view an <a href ="https://enstools.electionsnovascotia.ca/edinfo/"> electoral profile.</a></ul>
              <ul>Click here to view the <a href ="https://electionsnovascotia.ca/files/GIS/Maps/Ch%C3%A9ticamp-Margarees-Pleasant%20Bay.pdf"> electoral district map.</a></ul>
          </Typography>
        </Box>

        <Box id="french-services" mb={8}>
          <Typography variant="h4" mb={2}>French-Language Services</Typography>
          <Typography>
            Elections Nova Scotia is committed to providing high quality and accessible service to all voters. We strive to provide members of Nova Scotia&#39;s Acadian and Francophone communities access to a reasonably comparable level of service to that of the Anglophone community. To achieve this, we have developed a <a href ="https://www.electionsnovascotia.ca/Policies-And-Circulars">French-Language Services Policy</a>.
            <br/>
            As Chéticamp-Margarees-Pleasant Bay was defined by the 2025 Electoral Boundaries Commission as an exceptional district, having a large Acadian and Francophone population, all voter forms are available in French at voting locations and where possible French-language services are available at voting locations. Some social media messages will also be posted in French.
            <br/>  
            Most of the website content for the Chéticamp-Margarees-Pleasant Bay by-election has been provided in English and French. Some social media messages will also be posted in French.   
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Services en français </Typography>
          <Typography>
            Élections Nouvelle-Écosse tient à offrir des services fiables et accessibles à tous les électeurs. Nous mettons tout en œuvre pour que les membres des communautés acadienne et francophone de la Nouvelle-Écosse aient accès à un niveau de service raisonnablement comparable à celui de la communauté anglophone. Pour ce faire, nous avons mis en place une  <a href ="https://www.electionsnovascotia.ca/Policies-And-Circulars">politique relative aux services en français</a>.
            <br/>
            Étant donné que la Commission de délimitation des circonscriptions électorales de 2025 a établi Chéticamp-Margarees-Pleasant Bay comme circonscription exceptionnelle, et ce en raison de son importante population acadienne et francophone, tous les formulaires destinés aux électeurs sont disponibles en français dans les bureaux de vote, et des services en français y sont proposés lorsque cela est possible. 
            <br/>
            Une grande partie du contenu du site Web consacré à l’élection partielle de Chéticamp-Margarees-Pleasant Bay est disponible à la fois en français et en anglais. Certains messages publiés sur les réseaux sociaux seront également rédigés en français.
          </Typography>
        </Box>

        <Box id="election-workers" mb={8}>
          <Typography variant="h4" mb={2}>Election Workers Needed</Typography>
          {/* <ResponsiveImage src="/img/website image 2.jpg" alt="Starts with you" /> */}
          <Typography>
            It takes a lot of people and effort to make a by-election run smoothly. Elections Nova Scotia needs dedicated workers to facilitate voting during the current by-election in the electoral district of Chéticamp-Margarees-Pleasant Bay. People 18 years and older who would like to work the Chéticamp-Margarees-Pleasant Bay by-election are asked to please contact the returning office at 1-866-232-0016. There are also some jobs available for people ages 16 to 18. Bilingualism is an asset for workers in this by-election. 
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Besoin de personnel électoral</Typography>
          <Typography>
            L’organisation d’une élection partielle nécessite beaucoup de personnel et d’efforts. Élections Nouvelle-Écosse recherche donc des bénévoles pour aider au bon déroulement du scrutin lors de l’élection partielle dans la circonscription de Chéticamp-Margarees-Pleasant Bay. Les personnes âgées de 18 ans et plus qui souhaitent aider sont invitées à communiquer avec le bureau du directeur de scrutin au 1-866-232-0016. Il y a également des postes disponibles pour les jeunes de 16 à 18 ans. Être bilingue constitue un atout. 
          </Typography>
        </Box>

        <Box id="voting-options" mb={8}>
          <Typography variant="h4" mb={2}>Notice of Election - Elections that Work for you</Typography>
          <Typography>
            A by-election will be held on Tuesday, June 23, 2026, to elect a member to serve in the House of Assembly for the electoral district of Chéticamp-Margarees-Pleasant Bay. The following days are pursuant to the <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">Elections Act.</a>
            <br/><br/>
          </Typography>
          <Typography variant="h4" mb={2}>Voting Options</Typography> 
          <Typography>
            25 days of voting will be available for the Chéticamp-Margarees-Pleasant Bay by-election. Voting for the Chéticamp-Margarees-Pleasant Bay by-election began at the returning office on Tuesday, May 26, 2026.
            <br/>
            Prior to election day, eligible voters can vote early at the returning office or during a community poll. Voters can also apply to vote remotely by write-in ballot. Early voting before the close of candidate nominations will be done using the write-in ballot. Early voting after the close of nominations will be done by e-Balloting. Paper ballots will be used on election day.
            </Typography>
          {/* <ResponsiveImage src="/img/website image 3.jpg" alt="Voting Options" /> */}
          <br/>
          <Typography variant="h4" mb={2}>Returning Office</Typography> 
          <Typography>
            51 Old Cabot Trail RD, Grand Étang <br/>
            Open Monday to Saturday from 9 am to 6 pm<br/>
            Closed on Sundays<br/>
            Open for extended hours on Thursday, June 18 and Friday, June 19, 2026 from 9 am to 8 pm<br/>
            Open on Tuesday, June 23, 2026 from 8 am to 8 pm<br/>
            Returning Office contact number: 1-866-232-0016<br/>  
            <br/>        
          </Typography> 
          {/* <Typography variant="h4" mb={2}>Advance poll</Typography> 
          <Typography>
            ADDRESS, CITY, POSTAL CODE<br/>
            Saturday, June 13 – Saturday, June 20, 2026<br/>
            Open from 9 am to 6 pm<br/>
            Closed on Sundays<br/>
            Open for extended hours on Thursday, DATE XX and Friday DATE XX, 2026 from 9 am to 8 pm<br/><br/>     
          </Typography>   */}
          <Typography variant="h4" mb={2}>Election Day Voting</Typography> 
          <Typography>
            Election day is Tuesday, June 23, 2026<br/>
            Voting will be open from 8 am to 8 pm on election day.<br/>
            On election day, eligible voters in Chéticamp-Margarees-Pleasant Bay must vote at their assigned voting location or at the Returning Office.
          </Typography>       
        </Box>

        <Box id="where-vote" mb={8}>
          <Typography variant="h4" mb={2}>Where Do I Vote?</Typography>
          <Typography>
            If you live in Chéticamp-Margarees-Pleasant Bay, click <a href ="https://enstools.electionsnovascotia.ca/edinfo_wdiv/Location.aspx">here</a> and enter your civic address to find your voting location options.
          </Typography>
        </Box>

        <Box id="vic" mb={8}>
          <Typography variant="h4" mb={2}>Voter Information Cards (VIC)</Typography>
          <Typography>
            Registered voters in Chéticamp-Margarees-Pleasant Bay will receive a personalized voter information card (VIC) with information on where and when they can vote.
          </Typography>
        </Box>

        <Box id="who-can-vote" mb={8}>
          <Typography variant="h4" mb={2}>Who Can Vote in the Chéticamp-Margarees-Pleasant Bay by-election</Typography>
          <Typography>
            To be eligible to vote in the Chéticamp-Margarees-Pleasant Bay by-election, you must be:
          </Typography>
          <ul style={{ paddingLeft: "40px" }}>
            <li>18 years of age or older on Tuesday, June 23, 2026</li>
            <li>A Canadian citizen</li>
            <li>Live in Nova Scotia since November 23, 2025 (six months prior to the date the by-election was called)</li>
            <li>Reside in the electoral district of Chéticamp-Margarees-Pleasant Bay</li>
          </ul>
        </Box>


        <Box mb={8}>
          <Typography variant="h4" mb={2}>Avis d’élection - Des élections à votre service</Typography>
          <Typography>
            Une élection partielle aura lieu le mardi 23 juin 2026 afin d’élire un député pour la circonscription de Chéticamp-Margarees-Pleasant Bay. Les dates suivantes sont fixées conformément à la loi électorale  <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">(Elections Act).</a>
            <br/><br/>
          </Typography>
          <Typography variant="h4" mb={2}>Options pour le vote</Typography> 
          <Typography>
            Le vote lié à l’élection partielle de Chéticamp-Margarees-Pleasant Bay se déroulera sur vingt-cinq jours; il commencera au bureau du directeur du scrutin le Mardi 26 mai 2026
            <br/>
            Avant le jour de l’élection, les électeurs éligibles peuvent voter à l’avance au bureau de scrutin ou lors d’un bureau de vote communautaire. Les électeurs pourront également voter par correspondance. Le vote par anticipation, avant la clôture des candidatures, se fera à l’aide d’un bulletin de vote en blanc. Le vote par anticipation après la clôture des candidatures se fera par vote électronique. Le jour du vote, le vote se fera à l’aide de bulletins de vote papier.
            </Typography>
          {/* <ResponsiveImage src="/img/website image 3.jpg" alt="Voting Options" /> */}
          <br/>
          <Typography variant="h4" mb={2}>Bureau du directeur de scrutin</Typography> 
          <Typography>
            51 Chemin Old Cabot Trail Road, Grand Étang  <br/>
            Ouvert du lundi au samedi de 9 h à 18 h<br/>
            Fermé le dimanche<br/>
            Horaires prolongés le jeudi 18 juin et le vendredi 19 juin 2026, de 9 h à 20 h<br/>
            Ouvert le mardi 23 juin 2026, de 8 h à 20 h<br/>
            Numéro de téléphone du bureau du directeur de scrutin : 1-866-232-0016<br/>  
            <br/>        
          </Typography> 
          {/* <Typography variant="h4" mb={2}>Vote par anticipation</Typography> 
          <Typography>
            ADDRESS, CITY, POSTAL CODE<br/>
            Du samedi 13 juin au samedi 20 juin 2026<br/>
            Ouvert de 9 h à 18 h<br/>
            Fermé le dimanche<br/>
            Horaires prolongés le jeudi 18 juin et le vendredi 19 juin 2026, de 9 h à 20 h<br/><br/>     
          </Typography>   */}
          <Typography variant="h4" mb={2}>Vote le jour de l’élection</Typography> 
          <Typography>
            L’élection aura lieu le mardi 23 juin 2026.<br/>
            Les bureaux de vote seront ouverts de 8 h à 20 h le jour du vote.<br/>
            Les électeurs admissibles de Chéticamp-Margarees-Pleasant Bay devront voter dans le bureau de vote qui leur aura été attribué ou au bureau du directeur de scrutin.
          </Typography>       
        </Box>

        <Box id="where-vote" mb={8}>
          <Typography variant="h4" mb={2}>Où dois-je voter?</Typography>
          <Typography>
            Si vous habitez dans la circonscription de Chéticamp-Margarees-Pleasant Bay, cliquez  <a href ="https://enstools.electionsnovascotia.ca/edinfo_wdiv/Location.aspx">ici</a> puis entrez votre adresse municipale afin de voir les options qui s’offrent à vous pour voter.
          </Typography>
        </Box>

        <Box id="vic" mb={8}>
          <Typography variant="h4" mb={2}>Cartes d’information de l’électeur (CIE)</Typography>
          <Typography>
            Les électeurs inscrits dans la circonscription de Chéticamp-Margarees-Pleasant Bay recevront une carte d’information de l’électeur (CIE) personnalisée indiquant où et quand ils peuvent voter.
          </Typography>
        </Box>

        <Box id="who-can-vote" mb={8}>
          <Typography variant="h4" mb={2}>Qui peut voter lors de l’élection partielle de Chéticamp-Margarees-Pleasant Bay?</Typography>
          <Typography>
            Afin de pouvoir voter lors de l’élection partielle de Chéticamp-Margarees-Pleasant Bay, vous devez :
          </Typography>
          <ul style={{ paddingLeft: "40px" }}>
            <li>être âgé d’au moins 18 ans le mardi 23 juin 2026;</li>
            <li>être citoyen canadien;</li>
            <li>vivre en Nouvelle-Écosse depuis le 23 novembre 2025 (six mois avant la date à laquelle l’élection partielle a été déclenchée);</li>
            <li>résider dans la circonscription électorale de Chéticamp-Margarees-Pleasant Bay.</li>
          </ul>
        </Box>
  
        <Box id="register" mb={8}>
          <Typography variant="h4" mb={2}>Register for the Chéticamp-Margarees-Pleasant Bay by-election</Typography>
          <ResponsiveImage src="/img/website image 4.jpg" alt="Register" />
          <Typography>
            Elections Nova Scotia maintains a register of anyone eligible to vote in a Nova Scotia provincial general election or by-election. The Register is updated regularly and there are several ways to be added to the list. Though being registered before arriving at a voting location is not required, registered voters living in Chéticamp-Margarees-Pleasant Bay will be sent a personalized Voter Information Card (VIC) with information on where and when to vote. Click <a href ="https://electionsnovascotia.ca/voters">here</a> for more information on how to register to vote. 
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Inscrivez-vous pour voter lors de l’élection partielle de Chéticamp-Margarees-Pleasant Bay</Typography>
          <Typography>
            Élections Nouvelle-Écosse dresse un registre de toutes les personnes pouvant voter lors d’une élection générale ou d’une élection partielle en Nouvelle-Écosse. Ce registre est régulièrement mis à jour, et vous pouvez vous y inscrire de plusieurs façons. Il n’est pas obligatoire d’être inscrit avant de se rendre au bureau de vote, mais les électeurs inscrits résidant dans la circonscription de Chéticamp-Margarees-Pleasant Bay recevront une carte d’information de l’électeur (CIE) personnalisée indiquant où et quand voter.  <a href ="https://electionsnovascotia.ca/voters">Cliquez ici pour savoir comment vous inscrire pour voter</a>
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>First Time Voters – Get Registered!</Typography>
          <Typography>
            Elections Nova Scotia encourages first time voters in the electoral district of Chéticamp-Margarees-Pleasant Bay to register to vote. Voters can register any time online to ensure they are on the Nova Scotia Registry of Electors.<br/>
            New voters include young adults 18 years of age or older, new Canadian citizens, or voters who have moved to Nova Scotia and have not yet voted in a provincial election.<br/>
            <a href ="https://electionsnovascotia.ca/voters">Cliquez ici pour savoir comment vous inscrire pour voter.</a>
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Vous votez pour la première fois? Inscrivez-vous!</Typography>
          <Typography>
            Élections Nouvelle-Écosse invite les nouveaux électeurs de la circonscription de Chéticamp-Margarees-Pleasant Bay à s’inscrire pour voter. Pour vous assurer d’être inscrits sur le registre électoral de la Nouvelle-Écosse, inscrivez-vous en ligne à tout moment.<br/>
            Les nouveaux électeurs comprennent les adultes âgés de 18 ans ou plus, les nouveaux citoyens canadiens ainsi que les électeurs qui ont déménagé en Nouvelle-Écosse et qui n’ont pas encore voté lors d’une élection provinciale.<br/>
            Click <a href ="https://electionsnovascotia.ca/voters">here</a> for more information on how to register to vote. 
          </Typography>
        </Box> 

        <Box id="bring-id" mb={8}>
          <Typography variant="h4" mb={2}>Bring your ID</Typography>
          <ResponsiveImage src="/img/website image 5.png" alt="Id" />
          <Typography>
           It is always good to bring identification with your current name and address when you vote but it is not necessary.
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Apportez une pièce d’identité</Typography>
          <Typography>
           Lorsque vous allez voter, il est conseillé d’avoir avec soi une pièce d’identité indiquant votre nom et votre adresse actuelle; cela n’est toutefois pas obligatoire.
          </Typography>
        </Box>

        <Box id="write-in" mb={8}>
          <Typography variant="h4" mb={2}>Write-in Ballot</Typography>
          <Typography>
           Eligible voters in Chéticamp-Margarees-Pleasant Bay can apply to vote remotely using a write-in ballot. Write-in ballot voting can be facilitated by mail, in-person by an agent, or a write-in ballot team can visit a voter&#39;s home. Voters can apply for a write-in ballot in person, by mail, or have a trusted friend or family member act as the voter&#39;s agent to help them apply. Once a voter has applied to vote by write-in ballot, that is the method of voting they must use. Write-in ballots are conducted every day except Sundays during the hours the returning office is open.<br/>
          <br/>The application deadline for a write-in ballot by mail is DAY, June 13, 2026 by 6 pm.<br/>
          <br/>The application deadline for a write-in ballot in-person or by agent is Tuesday, June 23, 2026 by 3 pm. <br/>
          <br/>All completed write-in ballots must be returned by 8 pm on Tuesday, June 23, 2026, to be counted. If a voter sends their completed write-in-ballot by mail, they must allow enough time for it to arrive and by election day to be counted. <br/>
          <br/>You can call the returning office at 1-866-232-0016 if you have questions about the write-in ballot application process.<br/>
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Bulletin de vote en blanc</Typography>
          <Typography>
           Les électeurs admissibles de Chéticamp-Margarees-Pleasant Bay peuvent demander de voter par correspondance à l’aide d’un bulletin de vote à remplir soi-même. Le vote par correspondance peut se faire par la poste, en personne par l’intermédiaire d’un représentant; une personne chargée du vote par correspondance peut également se rendre au domicile de l’électeur. Les électeurs peuvent demander un bulletin de vote à remplir soi-même en personne, par la poste, ou demander à un ami ou à un membre de la famille de les aider à en faire la demande. Lorsqu’un électeur demande à voter par correspondance, il doit utiliser cette méthode. Il est possible de voter par correspondance tous les jours pendant les heures d’ouverture du bureau de vote, sauf le dimanche.<br/>
          <br/>Pour voter par correspondance, la date limite de dépôt de la demande est le samedi 13 juin à 18 h. <br/>
          <br/>En personne ou par l’intermédiaire d’un représentant, la date limite de demande est le mardi 23 juin 2026 à 15 h. <br/>
          <br/>Pour être pris en compte, tous les bulletins de vote par correspondance dûment remplis doivent être retournés avant 20 h le mardi 23 juin 2026. Les électeurs qui envoient leur bulletin de vote par correspondance par la poste doivent s’assurer de le faire suffisamment à l’avance pour que celui-ci arrive à temps et soit pris en compte le jour du vote. <br/>
          <br/>Pour toute question sur le processus de demande de bulletin de vote par correspondance, ou pour prendre rendez-vous afin qu’une équipe chargée du vote par correspondance se rende à votre domicile, veuillez appeler le bureau électoral au 1-866-232-0016.   <br/>
          </Typography>
        </Box>

        <Box id="e-ballot" mb={8}>
          <Typography variant="h4" mb={2}>E-Balloting for Early Voting</Typography>
          {/* <ResponsiveImage src="/img/website image 6.jpg" alt="e-ballot" /> */}
          
          <Typography>
            E-Balloting will be used for early voting in the Chéticamp-Margarees-Pleasant Bay by-election following the close of candidate nominations at 2 pm on Wednesday, June 3, 2026. Before the close of candidate nominations, the write-in ballot will be used for early voting at the returning office. 
            <br/><br/>
            The e-Balloting system is safe and allows voters to select the candidate of their choice on a tablet behind the voting screen. Once a vote is cast, the e-Ballot system produces a paper voting receipt for the voter to place in the ballot box. 
            <br/><br/>
            E-Balloting allows fast and secure counting of early votes when the polls close on election night. This means the results of the Chéticamp-Margarees-Pleasant Bay by-election will be returned quickly and efficiently. 
            <br/><br/>
            Traditional paper ballots will be used for voting on election day (Tuesday, June 23, 2026). E-Balloting is only being offered during early voting prior to election day in Chéticamp-Margarees-Pleasant Bay. 
           </Typography>
           <br/>
           <Typography variant="h4" mb={2}>Vote électronique pour le vote anticipé </Typography>
          {/* <ResponsiveImage src="/img/website image 6.jpg" alt="e-ballot" /> */}
          
          <Typography>
            En ce qui concerne le vote par anticipation lors de l’élection partielle de Chéticamp-Margarees-Pleasant Bay, le vote électronique aura lieu après la clôture des candidatures, à 14 h le mercredi 3 juin 2026. Avant la clôture des candidatures, le vote par correspondance sera utilisé pour le vote par anticipation au bureau de vote. 
            <br/><br/>
            Le système de vote électronique est sûr et permet aux électeurs de voter pour le candidat de leur choix à l’aide d’une tablette, dans l’isoloir. À la fermeture des bureaux de vote le soir de l’élection, le vote électronique permet un dépouillement rapide et sûr des votes par anticipation. Les résultats de l’élection partielle de Chéticamp-Margarees-Pleasant Bay seront ainsi communiqués rapidement et efficacement. 
            <br/><br/>
            Les bulletins de vote papier traditionnels seront utilisés pour le vote le jour du scrutin (mardi 23 juin 2026). Le vote électronique est uniquement possible lors du vote par anticipation avant le jour du scrutin. 
           </Typography>
        </Box>

        <Box id="internet-voting" mb={8}>
          <Typography variant="h4" mb={2}>Is Internet Voting Available?</Typography>
          <Typography>
            E-Balloting is not internet voting. Both are electronic forms of voting, but e-Balloting takes place in-person at a voting location on a secure tablet while internet voting facilitates remote voting on the voter&#39;s own electronic device using the internet.  <br/>
            <i><b>Internet voting is not available during the Chéticamp-Margarees-Pleasant Bay by-election. </b></i>
          </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Est-il possible de voter sur Internet?</Typography>
          <Typography>
            Le vote électronique et le vote par Internet sont deux choses différentes. Dans les deux cas, il s’agit de voter à l’aide d’un support électronique, mais le vote électronique se fait en personne, dans un bureau de vote, sur une tablette sécurisée, alors que le vote par Internet permet de voter à distance depuis son propre appareil électronique.  <br/>
            <i><b>Il n’est pas possible de voter par Internet lors de l’élection partielle de Chéticamp-Margarees-Pleasant Bay.  </b></i>
          </Typography>
        </Box>

        {/* <Box id="accessibility" mb={8}>
          <Typography variant="h4" mb={2}>Accessibility and Accommodations for Underserved Voters</Typography>
          <ResponsiveImage src="/img/website image 7.jpg" alt="accessibility" />
          <Typography>
            Elections Nova Scotia&#39;s Diversity Liaison Officers can assist underserved voters to connect with the electoral process. If you need assistance for the Chéticamp-Margarees-Pleasant Bay by-election, you can contact the Diversity Liaison Officer at <a href="mailto:IDEAS@electionsnovascotia.ca">IDEAS@electionsnovascotia.ca</a>. 
            </Typography>
        </Box> */}

        <Box id="media" mb={8}>
          <Typography variant="h4" mb={2}>Chéticamp-Margarees-Pleasant Bay by-election Media Releases</Typography>
          <Typography>
            The following media releases have been issued for the Chéticamp-Margarees-Pleasant Bay by-election: 
            <ul style={{ paddingLeft: "40px" }}>
              <li><a href ="/news">Call for Election Workers in Chéticamp-Margarees-Pleasant Bay – May 27, 2026</a></li>
              <li><a href ="/news">Eligible Voters Encouraged to Register for the Chéticamp-Margarees-Pleasant Bay by-election – May 27, 2026</a></li>
              <li><a href ="/news">Early Voting Has Begun Ahead of Schedule for the Chéticamp-Margarees-Pleasant Bay By-election – May 26, 2026</a></li>
              <li><a href ="/news">Candidate and Party Spending Limits for the Chéticamp-Margarees-Pleasant Bay by-election – May 26, 2026</a></li>
              <li><a href ="/news">Candidate Nomination Fee Not Required for the Chéticamp-Margarees-Pleasant Bay by-election – May 25, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay by-election – May 25, 2026</a></li>
              <li><a href ="/news">Chéticamp-Margarees-Pleasant Bay by-election Called – May 24, 2026</a></li>
              <li><a href = "/news">Elections That Work For You – May 24, 2026 </a></li>        
            </ul>
            </Typography>
        </Box>

        <Box id="signage" mb={8}>
          <Typography variant="h4" mb={2}>Election Signage and Third-Party Advertising</Typography>
          {/* <ResponsiveImage src="/img/website image 8.jpg" alt="signage" /> */}
          <Typography>
            During the Chéticamp-Margarees-Pleasant Bay by-election, the <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">Elections Act</a> requires an authorization statement on all signs and advertising, including print, broadcast and online. The statement must be legible and state, “Authorized by the Official Agent for (name of candidate, registered party, individual, organization).” 
            <br/><br/>
            Areas along highways, including some within municipalities, are managed by the provincial Department of Public Works. People who have questions about signs along highways may call a toll-free number 1-844-696-7737 or email <a href="mailto:dpw-occ@novascotia.ca">dpw-occ@novascotia.ca</a>. 
            <br/><br/>
            During the Chéticamp-Margarees-Pleasant Bay by-election, third party advertising is also regulated. Third party advertising rules require that the third party identifies itself and it has authorized the advertising. There are limits to how much money can be spent by third parties during the election. According to the <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">Elections Act</a>, a third party is an individual or group that is not a candidate, registered political party, or registered electoral district association. A third-party election advertisement is a message that promotes or opposes a registered political party, the election of a certain candidate, or a candidate&#39;s position on an issue within the election period. 
            </Typography>
          <br/>
          <Typography variant="h4" mb={2}>Publicité électorale et de tiers</Typography>
          {/* <ResponsiveImage src="/img/website image 8.jpg" alt="signage" /> */}
          <Typography>
            En ce qui concerne l’élection partielle de Chéticamp-Margarees-Pleasant Bay, la loi électorale  <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">(Elections Act)</a> exige qu’une autorisation soit apposée sur toutes les affiches et publicités, qu’elles soient imprimées, diffusées à la télévision, à la radio ou en ligne. Cette mention doit être lisible et indiquer ce qui suit : « Autorisée par le représentant officiel de (nom du candidat, parti enregistré, individu, organisation) ».  
            <br/><br/>
            Les espaces situés le long des routes, y compris certains espaces à l’intérieur des municipalités, sont gérés par le ministère provincial des Travaux publics. Pour toute question concernant les affiches le long des routes, veuillez appeler sans frais le 1-844-696-7737 ou envoyer un courriel à  <a href="mailto:dpw-occ@novascotia.ca">dpw-occ@novascotia.ca</a>. 
            <br/><br/>
            Pendant l’élection partielle de Chéticamp-Margarees-Pleasant Bay, la publicité de tiers est réglementée. Les règles applicables exigent que le tiers s’identifie et indique qu’il a autorisé la publicité. Des limites ont été fixées pour les montants que les tiers peuvent dépenser pendant une élection. Selon la loi électorale <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">(Elections Act)</a>, un tiers est une personne ou un groupe qui n’est ni un candidat, ni un parti politique enregistré, ni une association de circonscription électorale enregistrée. La publicité électorale d’un tiers est un message qui soutient ou qui s’oppose à un parti politique enregistré, à l’élection d’un candidat donné ou à l’opinion d’un candidat sur une question particulière pendant la période électorale. 
            </Typography>
        </Box>

        <Box id="campaign-access" mb={8}>
          <Typography variant="h4" mb={2}>Campaign Access to Multi-unit Buildings</Typography>
          {/* <ResponsiveImage src="/img/website image 9.jpg" alt="Campaign access" /> */}
          <Typography>
          Elections Nova Scotia would like to remind landlords and administrators of multi-unit buildings and condominiums in the electoral district of Chéticamp-Margarees-Pleasant Bay that enumerators and candidates must be given access during a by-election. 
          <br/><br/>It is an offence under the <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">Elections Act</a> to impede a candidate when lawfully campaigning or an enumerator when gathering information for the Register of Electors during a by-election. 
          <br/><br/>Elections Nova Scotia has a <a href ="https://www.electionsnovascotia.ca/Policies-And-Circulars">policy</a> on campaign access to multi-unit buildings to help provide clarity and understanding for landlords, tenants, and candidates. 
            </Typography>
            <br/>
          <Typography variant="h4" mb={2}>Accès des équipes de campagne aux immeubles à logements multiples</Typography>
          {/* <ResponsiveImage src="/img/website image 9.jpg" alt="Campaign access" /> */}
          <Typography>
          Élections Nouvelle-Écosse rappelle aux propriétaires et aux gestionnaires d’immeubles à logements multiples et de copropriétés de la circonscription électorale de Chéticamp-Margarees-Pleasant Bay qu’ils doivent permettre aux recenseurs et aux candidats d’accéder à ces lieux pendant une élection partielle. 
          <br/><br/>Selon la loi électorale  <a href ="http://nslegislature.ca/legc/statutes/elections.pdf">(Elections Act)</a>, faire obstacle à un candidat dans le cadre d’une campagne électorale légale ou à un recenseur qui recueille des renseignements pour le registre des électeurs pendant une élection partielle constitue une infraction.
          <br/><br/>Afin d’aider les propriétaires, les locataires et les candidats à y voir plus clair, Élections Nouvelle-Écosse possède une  <a href ="https://www.electionsnovascotia.ca/Policies-And-Circulars">politique sur l’accès aux immeubles à logements multiples pendant une campagne électorale.</a>
            </Typography>
        </Box>

      </Container>
    </MKBox>
  );
}

export default CheticampInformation;
